import React from "react";

/**
 * Lightweight centered spinner shown while lazy-loaded routes fetch their chunk.
 * Kept intentionally simple — SSR-friendly, <2KB, no external deps.
 */
export default function PageLoader() {
  return (
    <div
      data-testid="page-loader"
      role="status"
      aria-live="polite"
      style={{
        minHeight: "50vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: "0.75rem",
        color: "#64748b",
        fontSize: "14px",
      }}
    >
      <div
        style={{
          width: 32,
          height: 32,
          border: "3px solid #e2e8f0",
          borderTopColor: "#0066CC",
          borderRadius: "50%",
          animation: "corvana-spin 0.9s linear infinite",
        }}
      />
      <span>Loading…</span>
      <style>{`@keyframes corvana-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
